import { useState } from 'react';
import { useAffiliateStats } from '@/hooks/useAffiliateStats';
import { Copy, Check, Users } from 'lucide-react';

export function AffiliateSidebarCTA() {
  const stats = useAffiliateStats();
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (!stats.referralLink) return;
    
    try {
      await navigator.clipboard.writeText(stats.referralLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  if (stats.loading || !stats.affiliateCode) return null;

  return (
    <div className="rounded-xl border border-purple-400/30 bg-gradient-to-br from-purple-500/10 to-pink-500/10 p-4 space-y-3">
      <div className="flex items-center gap-2">
        <Users className="h-4 w-4 text-purple-300" />
        <p className="text-xs font-bold uppercase tracking-wider text-purple-200">
          Earn $10 per friend
        </p>
      </div>
      
      <p className="text-xs text-white/70 leading-relaxed">
        Share your link and earn when friends reach $50 in earnings
      </p>

      <button
        onClick={handleCopy}
        className="w-full flex items-center justify-center gap-2 rounded-lg bg-purple-400 px-3 py-2 text-xs font-bold text-zinc-950 transition hover:bg-purple-300"
      >
        {copied ? (
          <>
            <Check className="h-3 w-3" />
            Copied!
          </>
        ) : (
          <>
            <Copy className="h-3 w-3" />
            Copy Link
          </>
        )}
      </button>

      {stats.referrals.length > 0 && (
        <p className="text-xs text-center text-white/50">
          {stats.referrals.length} {stats.referrals.length === 1 ? 'referral' : 'referrals'}
        </p>
      )}
    </div>
  );
}
